import React from 'react'

import { Tooltip } from '@mui/material'

type ConditionalTooltipProps = {
  title?: string
  children: React.ReactElement
}

const ConditionalTooltip = ({ title, children }: ConditionalTooltipProps) => {
  return title ? (
    <Tooltip title={title} arrow placement="right-start">
      {children}
    </Tooltip>
  ) : null
}

export default ConditionalTooltip
